<template>
  <div
    class="day-wrapper"
    :class="{ disabled: disabled, active: !disabled && labelType !== 'holiday'}"
  >
    <div class="day-header flx-40">
      <div class="day flx-60">{{ dayNumber }}</div>
      <div class="day-time flx-40 mt-10">
        <span>{{ workPeriod }}</span>
      </div>
    </div>
    <div class="day-content">
      <CalendarLabel
        v-if="labelType !== 'empty'"
        :title="labelTitle"
        :type="labelType"
        :height="24"
        :width="115"
        :bRadius="labelBRadius"
      />
      <div @click.prevent="openSpecModal">
        <CalendarLabel
          class="mt-10"
          v-if="checkIfAppointmentPossible"
          :title="secondLabelTitle"
          :type="secondLabelType"
          :height="24"
          :width="115"
          :bRadius="secondLabelBRadius"
        />
      </div>
      <div
        class="record-helper"
        v-if="reservations.length"
        @click="openModal"
        @focusout="closeModal"
        :tabindex="dayNumber"
      >Раскрыть</div>
    </div>
    <div class="modal" v-if="reservations.length && isOpenedModal">
      <div class="modal-header">
        <span class="text ml-10">{{ dayNumber }}</span>
        <span class="ml-5">{{ weekdayName }}</span>
      </div>
      <div class="modal-content-wrapper pl-20 pr-20">
        <div class="modal-content" ref="content">
          <div
            class="modal-content-item"
            v-for="(r, i) in reservations"
            :class="{
              'mt-10': i === 0,
              'mt-5': i > 0,
              'mb-30': i+1 === reservations.length}"
            :key="i"
          >{{ reservationTime(r) }}</div>
        </div>
      </div>
    </div>
    <RegisterTimeModal
      v-if="!isEmptySchedule"
      :date="schedule.day"
      :opened="isOpenedSpecModal"
      @reservation-created="reservationCreatedHandler"
      v-on:close-it="isOpenedSpecModal = false"
      :specialist="specialist"
      :services="services"
      v-on:choose-sect="(i) => this.chosenService = i"
      :periods="periods"
      :registrator="true"
      :org="company"
    ></RegisterTimeModal>
  </div>
</template>

<script>
import { Component, Vue, Prop } from "vue-property-decorator";
import { directive as onClickaway } from "vue-clickaway";
import { mapActions } from "vuex";
import { CalendarLabel } from "@/components/Scheduler";
import RegisterTimeModal from "@/components/modals/RegisterTimeModal.vue";
import { WEEKS, MONTH_TYPES } from "@/components/Scheduler/modules/constants";
import {
  generateWorkTime,
  generateReservationTime,
  getDayFromString,
  getMonthFromString,
  getYearFromString,
  daysInMonth,
  getDateFromString
} from "@/components/Scheduler/modules/helpers";

@Component({
  components: {
    CalendarLabel,
    RegisterTimeModal
  },
  directives: {
    onClickaway
  }, 
  methods: mapActions(["getReservationsByMonth"]),
})
export default class MonthDay extends Vue {
  @Prop() schedule;
  @Prop({ default: [] }) reservations;
  @Prop() dayNumber;
  @Prop() weekDay;
  @Prop({ default: false }) disabled;
  @Prop() company;
  @Prop() services;
  @Prop() specialist;

  dayTypesBRadius = {
    default: 4,
    holiday: 25,
    empty: 25
  };

  isOpenedModal = false;
  isOpenedSpecModal = false;
  chosenService = { duration: "00:30:00" };


  get isEmptySchedule() {
    if (!this.schedule) return true;
    return !Object.keys(this.schedule).length;
  }

  get isEmptyPeriods() {
    if (this.isEmptySchedule) return true;
    return !this.schedule.periods.length;
  }

  get isEmptyReservations() {
    return !this.reservations.length;
  }

  get labelTitle() {
    if (this.isEmptySchedule) return "Записаться";
    if (!this.isEmptyReservations) return "Заявки";
    if (!this.schedule.periods.length) return "Выходной";
    return "Записаться";
  }

  get labelType() {
    if (this.isEmptySchedule) return "empty";
    if (!this.isEmptyReservations) return "default";
    if (!this.schedule.periods.length) return "holiday";
    return "empty";
  }

  get labelBRadius() {
    const type = this.labelType;
    return this.dayTypesBRadius[type];
  }

  get secondLabelType() {
    return "empty";
  }

  get secondLabelTitle() {
    return "Записаться";
  }
  get secondLabelBRadius() {
    const type = this.secondLabelType;
    return this.dayTypesBRadius[type];
  }

  get workPeriod() {
    if (this.isEmptySchedule) return "";
    const work = this.schedule.periods.find(period => period.p_type === "work");
    if (!work) return "";
    return generateWorkTime(work.start_time, work.end_time);
  }

  get weekdayName() {
    return WEEKS[this.weekDay].short;
  }

  get checkIfAppointmentPossible() {
    // if (this.isEmptySchedule) return false
    const date = getDateFromString(this.schedule.day)
    const nowDate = getDateFromString(moment().format('DD.MM.YYYY'))
    console.log({ date, nowDate, schedule: this.schedule })
    if(date < nowDate) return false
    const stopList = ["holiday"];
    if (!stopList.includes(this.labelType)) {
      return true;
    }
    return false;
  }

  get periods() {
    if (this.isEmptyPeriods) return [];
    const companies = this.divideToCompanies(this.schedule.periods);
    const chosenCompany = companies.find(company => company.owner === this.company.name)
    const chosenDay = this.schedule.day
    console.log({ companies, company: this.company, day: this.chosenDay, chosenCompany });
    if (
      !chosenCompany ||
      !this.chosenService.name ||
      !chosenDay.length
    )
      return [];

    const start = chosenCompany.times.split(" - ")[0];
    const globEnd = chosenCompany.times.split(" - ")[1];
    const sect = this.chosenService.duration;
    const orders = this.sortedByDayOrders[chosenDay];
    const lunch = chosenCompany.periods.find(i => i.p_type === "lunch");
    const live = chosenCompany.periods.find(i => i.p_type === "live");
    const rest_time = chosenCompany.periods.find(
      i => i.p_type === "rest_time"
    );

    let redtime = [];
    chosenCompany.periods.map(i => {
      if (i.p_type === "rest_time") {
        redtime.push(i);
      }
    });

    //const lunch_and_rest_time = {...lunch, ...rest_time};
    return this.reorderSchedule(
      chosenDay,
      start,
      globEnd,
      sect,
      orders,
      lunch,
      redtime,
      live
    );

    //return this.workOnPeriods(start, globEnd, sect, orders, lunch_and_rest_time);
  }

  get sortedByDayOrders() {
    let orderedByDays = {};
    this.reservations.map(i => {
      let date = moment(i.date_time_reservation, "DD.MM.YYYY hh:mm").format(
        "DD.MM.YYYY"
      );
      i.timestamp = moment(date, "DD.MM.YYYY").unix();
      orderedByDays[date]
        ? orderedByDays[date].push(i)
        : (orderedByDays[date] = [i]);
    });
    return orderedByDays;
  }

  formatTime(time) {
    return moment(time, "HH:mm:ss").format("HH:mm");
  }

  divideToCompanies(periods) {
    let orgs = this.specialist.company;
    let companies = {};
    periods.map(i =>
      companies[i.owner]
        ? companies[i.owner].push(i)
        : (companies[i.owner] = [i])
    );

    let companiesArr = [];
    for (let key in companies) {
      let street_address = "";
      let workPers = [];
      orgs.map(i => {
        if (i.name === key) street_address = i.street_address;
      });
      companies[key].map(i => {
        if (i.p_type === "work") workPers.push(i);
      });
      companiesArr.push({
        owner: key,
        street_address: street_address,
        periods: companies[key],
        times: `${this.formatTime(workPers[0].start_time)} - ${this.formatTime(
          workPers[workPers.length - 1].end_time
        )}`
      });
    }
    
    return companiesArr;
  }

  reorderSchedule(
    chosenDay,
    start,
    globEnd,
    sect,
    orders,
    lunch,
    rest_time,
    live
  ) {
    let arr = [];
    let periods = [];

    if (lunch || (rest_time && rest_time.length > 0) || live) {
      if (live) {
        arr.push(live.start_time + "-" + live.end_time);
      }
      if (lunch) {
        arr.push(lunch.start_time + "-" + lunch.end_time);
      }
      if (rest_time.length > 0) {
        for (var k in rest_time) {
          arr.push(rest_time[k].start_time + "-" + rest_time[k].end_time);
        }
      }
      arr.push(start + "-" + null);
      arr.push(null + "-" + globEnd);
    } else {
      arr.push(start + "-" + globEnd);
    }

    arr.sort();

    let arr2 = [];
    if (arr.length > 1) {
      for (var k in arr) {
        var next = k * 1 + 1;
        if (next >= arr.length) {
          next = k;
        }
        var back = k * 1 - 1;
        if (back <= arr.length) {
          back = k;
        }
        if (arr[k].split("-")[0] == "null") {
          // do nothing
        } else if (arr[k].split("-")[1] == "null") {
          arr2.push(arr[k].split("-")[0] + "-" + arr[next].split("-")[0]);
        } else {
          if (arr[next].split("-")[0] == "null") {
            arr2.push(arr[k].split("-")[1] + "-" + arr[next].split("-")[1]);
          } else {
            arr2.push(arr[k].split("-")[1] + "-" + arr[next].split("-")[0]);
          }
        }
      }
    } else {
      arr2 = arr;
    }

    for (var k in arr2) {
      let orderArr;
      if (orders && orders.length > 0) {
        let tempOrderArr = [];
        for (var z in orders) {
          var st = arr2[k].split("-")[0].replace(":", "") * 1;
          var et = arr2[k].split("-")[1].replace(":", "") * 1;
          var idx =
            orders[z].date_time_reservation.split(" ")[1].replace(":", "") * 1;
          if (idx >= st && idx <= et) {
            tempOrderArr.push(orders[z]);
          }
        }
        if (tempOrderArr.length > 0) {
          orderArr = tempOrderArr;
        }
      }
      periods = periods.concat(
        this.workOnPeriods(
          arr2[k].split("-")[0],
          arr2[k].split("-")[1],
          sect,
          orderArr,
          {},
          chosenDay
        )
      );
    }
    return periods;
  }

  workOnPeriods(
    start,
    globEnd,
    sect,
    orders,
    lunch,
    chosenDay = "",
    filtered = false
  ) {
    if (filtered === true) {
      let tempOrderArr = [];
      for (var z in orders) {
        var st = start.replace(":", "") * 1;
        var et = globEnd.replace(":", "") * 1;
        var idx =
          orders[z].date_time_reservation.split(" ")[1].replace(":", "") * 1;
        if (idx >= st && idx <= et) {
          tempOrderArr.push(orders[z]);
        }
      }
      if (tempOrderArr.length > 0) {
        orders = tempOrderArr;
      }
    }

    let currentOrder = orders
      ? orders[0]
      : { date_time_reservation: "01.01.1970 23:59" };
    let current = start;
    let periods = [];

    let todayDay = moment().format("DD.MM.YYYY");
    let nowTime = moment().unix();
    let startTime = moment(start, "HH:mm").unix();
    if (todayDay == chosenDay && startTime < nowTime) {
      let finish = moment();
      let remainder = 15 - (finish.minute() % 15);
      current = moment(finish)
        .add(remainder, "minutes")
        .format("HH:mm");
    }

    function generatePeriods() {
      startTime = moment(current, "HH:mm").unix();
      if (todayDay == chosenDay && startTime < nowTime) {
        let finish = moment();
        let remainder = 15 - (finish.minute() % 15);
        current = moment(finish)
          .add(remainder, "minutes")
          .format("HH:mm");
      }

      let now = moment(current, "HH:mm");
      let dur = moment.duration(sect);
      let end = now.add(dur);

      if (end.diff(moment(globEnd, "HH:mm")) > 0) {
        return;
      }
      //if (lunch && (end.diff(moment(lunch.start_time, 'HH:mm:ss')) >= 0 && end.diff(moment(lunch.end_time, 'HH:mm:ss')) <= 0)) {
      if (
        lunch &&
        end.diff(moment(lunch.start_time, "HH:mm")) > 0 &&
        end.diff(moment(lunch.end_time, "HH:mm")) <= 0
      ) {
        current = moment(lunch.end_time, "HH:mm").format("HH:mm");
      } else if (
        end.diff(
          moment(currentOrder.date_time_reservation.split(" ")[1], "HH:mm")
        ) <= 0
      ) {
        periods.push({ start: current, end: end.format("HH:mm") });
        current = end.format("HH:mm");
      } else {
        current = moment(
          currentOrder.date_time_reservation.split(" ")[1],
          "HH:mm"
        )
          .add(moment.duration(currentOrder.duration))
          .format("HH:mm");
        currentOrder = orders[orders.indexOf(currentOrder) + 1]
          ? orders[orders.indexOf(currentOrder) + 1]
          : { date_time_reservation: "01.01.1970 23:59" };
      }
      generatePeriods();
    }
    generatePeriods();
    return periods;
  }

  reservationTime(reservation) {
    return generateReservationTime(
      reservation.date_time_reservation,
      reservation.duration
    );
  }

  openModal() {
    this.isOpenedModal = true;
  }

  openSpecModal() {
    this.isOpenedSpecModal = true;
  }

  reservationCreatedHandler(reservation) {
    console.log({ reservation });
    this.getDataFromApi()
    .then((r) => this.isOpenedSpecModal = false)
    .catch(err => console.error('err', err))
  }

  closeModal() {
    this.isOpenedModal = false;
  }

  async getDataFromApi() {
    const month = getMonthFromString(this.schedule.day)
    const year = getYearFromString(this.schedule.day)
    console.log({ schedule: this.schedule, month, year })

    await this.getReservationsByMonth({
      month,
      year,
      spec_slug: this.specialist.slug,
      monthType: MONTH_TYPES.CURRENT
    });
    await this.getReservationsByMonth({
      month: month - 1,
      year,
      spec_slug: this.specialist.slug,
      monthType: MONTH_TYPES.PREV
    });
    await this.getReservationsByMonth({
      month: month + 1,
      year,
      spec_slug: this.specialist.slug,
      monthType: MONTH_TYPES.NEXT
    });
  }

  mounted() {}
}
</script>

<style lang="stylus" scoped>
@import '../../../styles/main.core.vars.styl';

.day-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 270px;
  background: #FFFFFF;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
  border: 1px solid #E8E8E8;
  border-radius: 4px;

  &&.disabled {
    background: #edf3fb;
  }

  &&.active {
    border-top: 5px solid #2F80ED;
  }

  .day-header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-style: normal;
    font-weight: normal;
    text-align: center;
    color: #333333;

    .day {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      font-family: Didact Gothic;
      font-size: 24px;
      line-height: 31px;
    }

    .day-time {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      font-family: Montserrat;
      font-size: 13px;
      line-height: 16px;
    }
  }

  .day-content {
    flex: auto;
    position: relative;

    .record-helper {
      position: absolute;
      bottom: 5px;
      left: 5px;
      background: #f1f1f1;
      padding: 7px;
      border-radius: 10px;
      cursor: pointer;
    }
  }
}

.modal {
  position: absolute;
  z-index: 10;
  width: 170px;
  height: 300px;
  overflow-y: auto;
  left: 5px;
  bottom: -300px;
  background: #FFFFFF;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;

  .modal-header {
    .text {
      font-family: Didact Gothic;
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 31px;
    }
  }

  .modal-content {
    .modal-content-item {
      text-align: center;
      background: #F2F2F2;
      border-radius: 4px;
      font-family: Didact Gothic;
      font-style: normal;
      font-weight: normal;
      font-size: 15px;
      line-height: 20px;
    }
  }
}
</style>
